import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
// Self-host Inter Variable font (single file, smooth weight transitions)
import '@fontsource-variable/inter';
import Modal from 'react-modal';
import App from './App';

Modal.setAppElement('#root');

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);
